// Module
var code = `<svg xmlns="http://www.w3.org/2000/svg">
    <defs>
        <pattern id="diagonalStripes" width="20" height="20" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="20" stroke="#e7e7e7" stroke-width="20" vector-effect="non-scaling-stroke"/>
        </pattern>
    </defs>

    <rect width="100%" height="100%" fill="url(#diagonalStripes)"/>
</svg>`;
// Exports
export default code;